import { EventBus } from 'vtils'

export const boxBus = new EventBus<{
  buy: () => any
  shouldRefreshOrderList: () => any
}>()
